import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"; // rotes Warnsymbol
import getUserRoleFlags from "../hooks/useGetUserRoleFlags";

interface Props {
  children: React.ReactNode;
  creatorNeeded: boolean,
  adminNeeded: boolean
}

const ReuqirePermissions: React.FC<Props> = ({ children, creatorNeeded, adminNeeded }) => {
  const { isAdmin, isCreator } = getUserRoleFlags();
  const checkPermissions = () => {
    return (
      (!creatorNeeded || isCreator || isAdmin) && // Admin erfüllt Creator-Anforderung
      (!adminNeeded || isAdmin)                   // Admin-Anforderung
    );
  };
  const sufficientPermissions = checkPermissions();
  const [showDialog, setShowDialog] = useState(!sufficientPermissions);

  const handleClose = () => {
    setShowDialog(false);
  };

  if (!sufficientPermissions && !showDialog) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {sufficientPermissions ? children : null}
      <Dialog open={showDialog} onClose={handleClose}>
        <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
          <ErrorOutlineIcon sx={{ color: "red", fontSize: 40, mr: 2 }} />
          <DialogTitle sx={{ p: 0 }}>Access denied</DialogTitle>
        </Box>
        <DialogContent>
          <Typography>
            You are not permitted to access this site. Please contact Event Manager's administration team via email: event-manager@ek-robotics.com.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReuqirePermissions;